import React from 'react';
import { PERSONAL_INFO } from '../Constants';
import image from "../Assets/photo.png";
import About from './About';

const Hero = () => {
  return (
    <div className="min-h-screen w-full flex flex-col justify-center items-center bg-gradient-to-r from-blue-400 to-purple-600 text-white p-4">
      {/* Profile Image */}
      <img className="rounded-full w-32 h-32 sm:w-36 sm:h-36 md:w-48 md:h-48 mb-6" src={image} alt="Profile" />

      {/* Name */}
      <h1 className="text-3xl text-gray-800 sm:text-4xl md:text-5xl lg:text-6xl font-bold text-center">
        Hello, I'm {PERSONAL_INFO.name}
      </h1>

      {/* Title */}
      <p className="text-lg sm:text-xl text-gray-800  md:text-2xl lg:text-3xl mt-4 mb-2 text-center">
        {PERSONAL_INFO.title}
      </p>

      {/* About Section */}
      <div className="max-w-screen-sm w-full px-4">
        <About />
      </div>
    </div>
  );
};

export default Hero;
